import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "./motion";

export const Footer = () => {
  return (
    <footer data-testid="global-footer" className="bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="overflow-hidden"
        >
          <img
            src="/logo-full.png"
            alt="Equinox Infrastructure Holdings, LLC — official emblem"
            data-testid="footer-logo"
            className="h-44 sm:h-60 w-auto mb-6 opacity-90 mx-auto block"
          />
          <p className="font-display font-black uppercase leading-none tracking-tighter text-[9vw] lg:text-[8rem] whitespace-nowrap text-outline select-none flex items-baseline justify-center gap-x-[0.4em]">
            <span>Project</span>
            <span>Equinox</span>
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-12 gap-8 border-t border-zinc-800 pt-10">
          <div className="col-span-12 md:col-span-5">
            <p className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-3">
              Project Equinox Operations Division
            </p>
            <p className="text-xs leading-relaxed text-zinc-500 max-w-sm">
              Autonomous off-grid enclosure tranches engineered for institutional
              counterparties operating beyond terrestrial grid dependency.
            </p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <p className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-3">Compliance Routing</p>
            <a
              href="mailto:compliance@equinoxih.com"
              data-testid="footer-compliance-email"
              className="text-xs text-zinc-300 hover:text-white transition-colors duration-300"
            >
              compliance@equinoxih.com
            </a>
            <div className="mt-3">
              <a
                href="/compliance"
                data-testid="footer-compliance-desk-link"
                className="text-[10px] tracking-[0.25em] uppercase text-zinc-600 hover:text-white transition-colors duration-300"
              >
                Compliance Desk →
              </a>
            </div>
          </div>
          <div className="col-span-6 md:col-span-4">
            <p className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-3">Node Telemetry</p>
            <div className="flex items-center gap-2 text-xs text-zinc-300">
              <span className="status-dot inline-block w-1.5 h-1.5 rounded-full bg-green-500" />
              Secure System Node: Active
            </div>
            <p className="mt-2 text-[10px] text-zinc-600 uppercase tracking-widest">
              EO 14373 / U.S. Trustee Escrow Cleared
            </p>
          </div>
        </div>

        <div className="mt-14 border-t border-zinc-800 pt-6">
          <p data-testid="footer-copyright" className="text-[10px] leading-relaxed tracking-[0.08em] uppercase text-zinc-600">
            © 2026 Equinox Infrastructure Holdings, LLC. All rights reserved. Managed
            under strict U.S. banking infrastructure and SAM.gov cleared contractor
            tracking networks.
          </p>
        </div>
      </div>
    </footer>
  );
};
